module.exports = __webpack_public_path__ + "static/carpet-cleaning-bf4a52670bf95121247970d7a52607c8.jpg";